"use client"

import { getDepictProductsInListingViaExternalIdClient } from "@/actions/categories/get-depict-products-in-listing-via-external-id-client"
import { transformedFilterOptions } from "@/app/(site)/_components/Organisms/ProductGrids/helpers"
import { CurrencyFormat } from "@/lib/depict-client/helpers/formatPricesInTransformedData"
import { transformDepictDisplayResponse } from "@/lib/depict-client/helpers/transformDepictResponse"
import { ProductListingResponseV3 } from "@/lib/depict-client/types/api/ProductListingResponseV3"
import logger from "@/lib/logger/logger-init"

type FetchProductsKey = [
    string, // fetcherKey
    string | undefined,
    string,
    string,
    string,
    string,
    string,
    number,
    string | null,
    string | undefined
]

export const getDepictProductsInListingViaExternalIdSwr = async (
    key: FetchProductsKey,
    centraSessionCurrencyFormat: CurrencyFormat | undefined
) => {
    const [
        ,
        externalId,
        merchant,
        marketCode,
        localeCode,
        depictSessionId,
        filtersString,
        limit,
        sortString,
        cursor
    ] = key
    const filters = JSON.parse(filtersString)
    const sort = sortString ? JSON.parse(sortString) : undefined

    const params = {
        cursor,
        filters,
        limit,
        merchant,
        externalId,
        marketCode,
        localeCode,
        depictSessionId,
        sort
    }

    try {
        const response = await getDepictProductsInListingViaExternalIdClient({
            market: params.marketCode,
            locale: params.localeCode,
            merchant: params.merchant,
            external_id: params.externalId || "",
            session_id: params.depictSessionId,
            limit: params.limit,
            cursor: params.cursor || undefined,
            filters: transformedFilterOptions(params.filters),
            sort:
                params.sort && params.sort.field !== "_relevance"
                    ? params.sort
                    : undefined,
            centraSessionCurrencyFormat: centraSessionCurrencyFormat
        })

        return {
            products: transformDepictDisplayResponse(
                response as ProductListingResponseV3,
                "item_group_id"
            ),
            cursor:
                (response as { displays: { [k: string]: unknown }[]; cursor?: string })
                    .cursor || null
        }
    } catch (error) {
        logger.error("Error fetching products:", error)
        throw error
    }
}
